module.exports = __webpack_public_path__ + "static/media/logo-light.2e58279d.png";